import { Pipe, PipeTransform } from '@angular/core';
import {
   ExtensionChipInputOption,
   ExtensionChipInputType,
} from 'src/app/common-components/entity-select/extension/chip-input/extension-phone-number.model';
import { ExtensionOption } from 'src/app/pages/extension-register/models/extension-option.interface';
import { formatPhoneNumbers } from '../format-phone-numbers/format-phone-numbers.pipe';

@Pipe({
    name: 'formatPhoneNumberOrExtension',
    standalone: false
})
export class FormatPhoneNumberOrExtensionPipe implements PipeTransform {
   transform(value: ExtensionChipInputOption): string {
      return formatPhoneNumberOrExtension(value);
   }
}

export function formatPhoneNumberOrExtension(value: ExtensionChipInputOption): string {
   if (value.type === ExtensionChipInputType.Extension) {
      return `${(value.value as ExtensionOption).number} - ${(value.value as ExtensionOption).name}`;
   } else {
      return formatPhoneNumbers(value.value as string);
   }
}

export function formatExternalNumber(value): string {
   if (value.Conains('(Outside Line)')) {
      return formatPhoneNumbers(value as string);
   }
   return ';';
}
